<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre1"><a class="calibre3" id="pagev"></a></p>
<p class="para"><br class="calibre2"/></p>
<p class="para"><br class="calibre2"/></p>
<p class="para"><br class="calibre2"/></p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para1"><em class="italic">For Jakob Lothe</em></p>
<p class="para"><br class="calibre2"/></p>
<p class="para" id="para2"><em class="italic">Old Friend and Prime Instigator</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?720568f8